export default function CultureService() {

            /**
             * Match of currency ISO codes to currency signs
             */
            const currencySigns = {
                USD: '$',
                GBP: '£',
                EUR: '€',
                CAD: '$',
                KES: 'K',
                CHF: 'F',
            };

            /**
             * Contacts for each regions
             */
            const contactInfo = {
                US: {tel: '+1 646 289 6838', email: 'helpdesk-us@keytravel.com'},
                UK: {tel: '+44 (0)844 335 0260', email: 'helpdesk-uk@keytravel.com'},
                BE: {tel: '+32 (0)2 627 5309', email: 'helpdesk-be@keytravel.com'},
                FR: {tel: '+33 1 45 55 50 31', email: 'helpdesk-be@keytravel.com'},
            };

            /**
             * Culture date formats/currency sign
             */
            const cultureFormats = {
                'en-US': {
                    dateFormat: 'MM/DD/YYYY',
                    timeFormat: 'h:mma',
                    mediumTimeFormat: 'HH:mm:ss',
                    dateTimeFormat: 'MM/DD/YYYY h:mma',
                    shortMonthDateFormat: 'MMM dd',
                    shortMonthDateFormatMoment: 'MMM DD',
                    shortDayMonthDateFormat: 'EEE, MMM d',
                    shortDayMonthDateFormatMoment: 'ddd, MMM D',
                    shortDayMonthDateTimeFormat: 'EEE, MMM d, h:mma',
                    shortDayMonthDateTimeFormatMoment: 'ddd, HH:mm, D MMM',
                    shortMonthDateTimeFormat: 'MMM DD h:mma',
                    mediumDayMonthDateFormat: 'ddd, MMM DD',
                    timeHoursOnlyFormat: 'h:00a',
                    shortDayWithTimeFormat: 'ddd, h:mma',
                    ISO: 'YYYY-MM-DDTHH:mm:ss',
                    fullDayMonDateYearFormat: 'dddd, DD MMM YYYY',
                },
                'en-GB': {
                    dateFormat: 'DD/MM/YYYY',
                    timeFormat: 'HH:mm',
                    mediumTimeFormat: 'HH:mm:ss',
                    dateTimeFormat: 'DD/MM/YYYY HH:mm',
                    shortMonthDateFormat: 'dd MMM',
                    shortMonthDateFormatMoment: 'DD MMM',
                    shortDayMonthDateFormat: 'EEE, d MMM',
                    shortDayMonthDateFormatMoment: 'ddd, D MMM',
                    shortDayMonthDateTimeFormat: 'EEE, HH:mm, d MMM',
                    shortDayMonthDateTimeFormatMoment: 'ddd, HH:mm, D MMM',
                    shortMonthDateTimeFormat: 'DD MMM HH:mm',
                    mediumDayMonthDateFormat: 'ddd, DD MMM',
                    timeHoursOnlyFormat: 'HH:00',
                    shortDayWithTimeFormat: 'ddd, HH:mm',
                    ISO: 'YYYY-MM-DDTHH:mm:ss',
                    fullDayMonDateYearFormat: 'dddd, DD MMM YYYY',
                },
                'fr-FR': {
                    dateFormat: 'DD/MM/YYYY',
                    timeFormat: 'HH:mm',
                    mediumTimeFormat: 'HH:mm:ss',
                    dateTimeFormat: 'DD/MM/YYYY HH:mm',
                    shortMonthDateFormat: 'dd MMM',
                    shortMonthDateFormatMoment: 'DD MMM',
                    shortDayMonthDateFormat: 'EEE, d MMM',
                    shortDayMonthDateFormatMoment: 'ddd, D MMM',
                    shortDayMonthDateTimeFormat: 'EEE, HH:mm, d MMM',
                    shortDayMonthDateTimeFormatMoment: 'ddd, HH:mm, D MMM',
                    shortMonthDateTimeFormat: 'DD MMM HH:mm',
                    mediumDayMonthDateFormat: 'ddd, DD MMM',
                    timeHoursOnlyFormat: 'HH:00',
                    shortDayWithTimeFormat: 'ddd, HH:mm',
                    ISO: 'YYYY-MM-DDTHH:mm:ss',
                    fullDayMonDateYearFormat: 'dddd, DD MMM YYYY',
                },
                'nl-NL': {
                    dateFormat: 'DD/MM/YYYY',
                    timeFormat: 'HH:mm',
                    mediumTimeFormat: 'HH:mm:ss',
                    dateTimeFormat: 'DD/MM/YYYY HH:mm',
                    shortMonthDateFormat: 'dd MMM',
                    shortMonthDateFormatMoment: 'DD MMM',
                    shortDayMonthDateFormat: 'EEE, d MMM',
                    shortDayMonthDateFormatMoment: 'ddd, D MMM',
                    shortDayMonthDateTimeFormat: 'EEE, HH:mm, d MMM',
                    shortDayMonthDateTimeFormatMoment: 'ddd, HH:mm, D MMM',
                    shortMonthDateTimeFormat: 'DD MMM HH:mm',
                    mediumDayMonthDateFormat: 'ddd, DD MMM',
                    timeHoursOnlyFormat: 'HH:00',
                    shortDayWithTimeFormat: 'ddd, HH:mm',
                    ISO: 'YYYY-MM-DDTHH:mm:ss',
                    fullDayMonDateYearFormat: 'dddd, DD MMM YYYY',
                },
                'de-DE': {
                    dateFormat: 'DD/MM/YYYY',
                    timeFormat: 'HH:mm',
                    mediumTimeFormat: 'HH:mm:ss',
                    dateTimeFormat: 'DD/MM/YYYY HH:mm',
                    shortMonthDateFormat: 'dd MMM',
                    shortMonthDateFormatMoment: 'DD MMM',
                    shortDayMonthDateFormat: 'EEE, d MMM',
                    shortDayMonthDateFormatMoment: 'ddd, D MMM',
                    shortDayMonthDateTimeFormat: 'EEE, HH:mm, d MMM',
                    shortDayMonthDateTimeFormatMoment: 'ddd, HH:mm, D MMM',
                    shortMonthDateTimeFormat: 'DD MMM HH:mm',
                    mediumDayMonthDateFormat: 'ddd, DD MMM',
                    timeHoursOnlyFormat: 'HH:00',
                    shortDayWithTimeFormat: 'ddd, HH:mm',
                    ISO: 'YYYY-MM-DDTHH:mm:ss',
                    fullDayMonDateYearFormat: 'dddd, DD MMM YYYY',
                },
                'it-IT': {
                    dateFormat: 'DD/MM/YYYY',
                    timeFormat: 'HH:mm',
                    mediumTimeFormat: 'HH:mm:ss',
                    dateTimeFormat: 'DD/MM/YYYY HH:mm',
                    shortMonthDateFormat: 'dd MMM',
                    shortMonthDateFormatMoment: 'DD MMM',
                    shortDayMonthDateFormat: 'EEE, d MMM',
                    shortDayMonthDateFormatMoment: 'ddd, D MMM',
                    shortDayMonthDateTimeFormat: 'EEE, HH:mm, d MMM',
                    shortDayMonthDateTimeFormatMoment: 'ddd, HH:mm, D MMM',
                    shortMonthDateTimeFormat: 'DD MMM HH:mm',
                    mediumDayMonthDateFormat: 'ddd, DD MMM',
                    timeHoursOnlyFormat: 'HH:00',
                    shortDayWithTimeFormat: 'ddd, HH:mm',
                    ISO: 'YYYY-MM-DDTHH:mm:ss',
                    fullDayMonDateYearFormat: 'dddd, DD MMM YYYY',
                },
            };

            return {
                getCultureSettings: function(settings, country) {
                    const response = angular.copy(cultureFormats[settings.Culture]);
                    response.currency = settings.Currency;
                    response.currencySign = currencySigns[settings.Currency] || settings.Currency;
                    response.distanceUnit = settings.DistanceUnit;
                    response.culture = settings.Culture;
                    response.gmtOffset = settings.GmtOffset;
                    response.contactInfo = contactInfo[country];
                    return response;
                },

                getCurrencySign: function(currency) {
                    return currencySigns[currency] || currency;
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/services/cultureService.js